// extracted by mini-css-extract-plugin
export default {"textBlock":"Shipping_textBlock__Bm7mT","article":"Shipping_article__HLpSn"};